import { inject, Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { CachingService } from '../services/caching.service';
import { concatMap, take } from 'rxjs/operators';
import { UtilityService } from '../services/utility.service';

@Injectable()
export class AttachTokenInterceptor implements HttpInterceptor {
  constructor(private cachingService: CachingService) {}
  utilityService = inject(UtilityService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const doesTokenNeedsToAttach = req.params.get('isAuth') === 'true';

    if (doesTokenNeedsToAttach && this.utilityService.isUserLoggedIn()) {
      return this.cachingService.loggedInUser.pipe(
        take(1),
        concatMap(({ token }) => {
          const clonedRequest = req.clone({
            headers: req.headers.append('Authorization', `Bearer ${token}`),
          });

          return next.handle(clonedRequest);
        }),
      );
    } else {
      const clonedReq = req.clone({ params: req.params.delete('isAuth') });
      return next.handle(clonedReq);
    }
  }
}
